// Mounted once at app root. Listens for the first successful Hub
// generation (chat / image / research / analyze) on this device and,
// if the visitor is signed-out, opens the AuthModal in `signup` mode so
// they can save their work before the next prompt.
//
// Intentionally only triggers ONCE per browser — handled by the bus
// itself (`emitFirstOutput` no-ops after the first emit). For signed-in
// users we still mark the flag (the bus does it on emit) so they never
// get a stale prompt later if they sign out.
import { useEffect, useState } from "react";
import AuthModal from "@/components/AuthModal";
import { useAuth } from "@/hooks/useAuth";
import { subscribeFirstOutput } from "@/lib/firstOutputBus";

const FirstOutputSignupGate = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    return subscribeFirstOutput(() => {
      // Only nudge anonymous visitors. Signed-in users already have an
      // account; firing this for them would be pure annoyance.
      if (user) return;
      setOpen(true);
    });
  }, [user]);

  return <AuthModal open={open} onClose={() => setOpen(false)} defaultMode="signup" />;
};

export default FirstOutputSignupGate;